import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Paper } from "@mui/material";
import { setAlert } from "../../../action/alert";
import { format } from "date-fns";
import DataTable from "../../Common/DataTable/DataTable";
import EmptyState from "../../Common/EmptyState/EmptyState";

const DeviceConnDisconnLogs = ({
  deviceDetails,
  getDeviceConnDisconnLogsData,
  connectionStatusLogs,
}) => {
  const [deviceConnDisconnLogsData, setDeviceConnDisconnLogsData] = useState(
    []
  );
  const [isLoading, setIsLoading] = useState(false);
  const headers = {
    serialNumber: "S.No",
    onlineStatus: "Status",
    timestamp: "Timestamp",
  };
  const columns = [
    {
      key: "serialNumber",
      label: headers.serialNumber,
      minWidth: 100,
      render: (_, row) => row.serialNumber,
    },
    {
      key: "onlineStatus",
      label: headers.onlineStatus,
      minWidth: 160,
      render: (value) => (
        <Box
          component="span"
          sx={{
            color: value === true ? "green" : "red",
            fontWeight: "bold",
            wordBreak: "break-all",
          }}
        >
          {value === true ? "Online" : "Offline"}
        </Box>
      ),
    },
    {
      key: "timestamp",
      label: headers.timestamp,
      align: "right",
      justifyContent: "flex-end",
      minWidth: 220,
      render: (value) =>
        value ? format(new Date(value), "dd MMM yyyy, hh:mm a") : "-",
    },
  ];

  useEffect(() => {
    if (
      deviceDetails &&
      deviceDetails instanceof Object &&
      deviceDetails.hasOwnProperty("deviceId")
    ) {
      setIsLoading(true);
      getDeviceConnDisconnLogsData(deviceDetails?.deviceId ?? "", () => {
        setIsLoading(false);
      });
    }
  }, [deviceDetails, getDeviceConnDisconnLogsData]);

  useEffect(() => {
    setDeviceConnDisconnLogsData(connectionStatusLogs);
  }, [connectionStatusLogs]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "grid",
          placeItems: "center",
          minHeight: "40vh",
          mt: 2,
          mb: 2,
          py: 2,
        }}
      >
        <CircularProgress size={60} sx={{ color: "#AFB42B" }} />
      </Box>
    );
  }
  const connDisconnRows = deviceConnDisconnLogsData.map((element, index) => ({
    ...element,
    serialNumber: index + 1,
  }));
  const hasConnDisconnData = Array.isArray(connDisconnRows) && connDisconnRows.length > 0;

  return (
    <Box sx={{ width: "100%", minWidth: 0, mt: 2, mb: 2 }}>
    <Paper
      sx={{
        p: 2,
        boxShadow: 2,
        borderRadius: 1,
        overflow: "hidden",
      }}
    >
      {!hasConnDisconnData ? (
        <EmptyState
          message="No Data found"
          sx={{ bgcolor: "transparent", p: 0 }}
        />
      ) : (
        <DataTable
          columns={columns}
          data={connDisconnRows}
          rowKey="serialNumber"
          minWidth="100%"
          tableContainerSx={{ boxShadow: "none", borderRadius: 0, width: "100%", minWidth: 0 }}
          msgForDisplay="No Data found"
          sx={{
            overflow: "auto",
            scrollBehavior: "auto",
          }}
        />
      )}
    </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setCustomAlert: (message, alertType) =>
    dispatch(setAlert(message, alertType)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceConnDisconnLogs);
